var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoIconSmall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "likiee",
    transform: "translate(-629 -346)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_87",
    "data-name": "Ellipse 87",
    cx: 10,
    cy: 10,
    r: 10,
    transform: "translate(629 346)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_11342",
    "data-name": "Group 11342"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8358",
    "data-name": "Path 8358",
    d: "M43.408,25.089a12.094,12.094,0,0,1-.616,3,9.768,9.768,0,0,1-.846-7.624c.194-.426.377-.548.446-.553h.029a.267.267,0,0,1,.191.1c.5.49.959,2.29.788,5.074",
    transform: "translate(594.98 329.859)",
    fill: "#ff411a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8359",
    "data-name": "Path 8359",
    d: "M11.392,19.883a9.942,9.942,0,0,1-4.387-.361c.328-.419.67-.877,1-1.357a23.271,23.271,0,0,0,1.613-2.759,3,3,0,0,0,1.521.065c2.438-.512,4.428-3.953,4.927-6.235a4.028,4.028,0,0,0-.388-3.247,2.422,2.422,0,0,0-1.568-1.05,2.664,2.664,0,0,0-1.862.386.944.944,0,1,0,.964,1.624.8.8,0,0,1,.581-.148.514.514,0,0,1,.323.244,2.335,2.335,0,0,1,.108,1.8c-.422,1.912-2.066,4.487-3.476,4.776a1.029,1.029,0,0,1-.361.022A15.19,15.19,0,0,0,11.4,9.217c.094-1.561.15-5.356-1.4-6.881A2.137,2.137,0,0,0,8.288,1.7,2.5,2.5,0,0,0,6.244,3.381a10.033,10.033,0,0,0-.57,5A11.37,11.37,0,0,0,7.624,13.85a5.263,5.263,0,0,0,.4.493A45.766,45.766,0,0,1,5.2,18.748a10,10,0,1,1,6.192,1.131",
    transform: "translate(628.998 346.019)",
    fill: "#ff411a"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoIconSmall);
export default __webpack_public_path__ + "static/media/logo-icon-small.9dd02386.svg";
export { ForwardRef as ReactComponent };